import { Dispatch, useEffect } from "react";
import { AppointmentsApi } from "../../Api/AppointmentsApi";
import { AppointmentDto } from "../../../../Api/Model/AppointmentDto.csharp";
import { FormFields, FormReducer } from "../Helpers/formTypes";
import { isObjectEmpty } from "../Helpers";

const appointmentsApi = new AppointmentsApi();

export const useCancellationDeadline = (
    appointment: AppointmentDto,
    dispatch: Dispatch<any>
) => {
    useEffect(() => {
        if(!appointment.serviceVariantId){
            dispatch({
                type: FormReducer.update,
                field: FormFields.cancellationDeadline,
                payload: null,
            });
        }
        (async () => {
            if (
                !isObjectEmpty(appointment) &&
                appointment.serviceVariantId
            ) {

                const cancellationDeadline = await appointmentsApi.getCancellationDeadline(
                    appointment.serviceId,
                    appointment.centerId,
                    appointment.startTime
                );
                if(cancellationDeadline != null){
                    dispatch({
                        type: FormReducer.update,
                        field: FormFields.cancellationDeadline,
                        payload: cancellationDeadline,
                    });
                }
            }
        })();
    }, [appointment]);
};
